import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { LogoInfo, ResultLogoInfo } from '../interfaces/LogoIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C601LogoGetProps {
  execLogoGet: (deviceId: string) => Promise<ResultLogoInfo>
  loading: loadStatus
}
// C601 ロゴ一覧取得API呼出
export const useC601LogoGet = (): C601LogoGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execLogoGet = async (deviceId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        buildDeviceUrl(deviceId, apiUrl.logosPath),
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        if (response.data !== '') {
          const infos: LogoInfo[] = response.data.map((logo: LogoInfo) => {
            return {
              ...logo,
              storage_path: String(logo.storage_path),
            }
          })
          // console.log(infos);
          setLoading(loadStatus.LOADED)
          return { success: true, info: infos }
        }
        const infos: LogoInfo[] = []
        setLoading(loadStatus.LOADED)
        return { success: true, info: infos }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execLogoGet, loading }
}
